import { atom } from 'recoil';

export interface IGeoBound {
  GeoBoundaryId: string;
  AccountId: string;
  AccountName: string;
  GeoBoundaryName: string;
  GeoBoundaryTypeId: string;
  GeoBoundaryShape: string;
  Latitude: string;
  Longitude: string;
  Radius: string;
  Address: string;
  Suburb: string;
  PostCode: string;
  IsOffroad: string;
  GeoPath?: unknown;
}
export const geoBoundaryTabListState = atom<IGeoBound[]>({
  key: "geoBoundaryTabListState",
  default: [],
});

export const geoBoundaryTabIndexState = atom({
  key: "geoBoundaryTabIndexState",
  default: 0,
});

export const geoBoundaryListRefreshState = atom({
  key: "geoBoundaryListRefreshState",
  default: true,
});